import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Email = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="email icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M0.000273192 5.95276C9.12304e-05 5.96849 0 5.98423 0 6V18C0 20.2091 1.79086 22 4 22H20C22.2091 22 24 20.2091 24 18V6C24 5.98423 23.9999 5.96849 23.9997 5.95276L12 15.9525L0.000273192 5.95276Z"
    />
    <path
      className={pathClass}
      d="M1.25347 3.09197L12 12.0474L22.7465 3.09197C22.03 2.41503 21.0635 2 20 2H4C2.93651 2 1.96995 2.41503 1.25347 3.09197Z"
    />
  </svg>
)
